import { hot } from 'react-hot-loader/root';
import { connect } from 'react-redux';
import { selectPayloadObject } from '../../../ReduxStorage/location/selectors.common';
import { ReduxState } from '../../../ReduxStorage/state';
import { InstitutionAdminSettings } from './component';

export const ConnectedInstitutionAdminSettings = hot(
  connect((state: ReduxState) => ({
    locationPayload: selectPayloadObject(state),
  }))(InstitutionAdminSettings)
);
